import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.css";

export default function InfoMessage({ children }) {
  if (!children) return null;

  return (
    <div className={styles.message}>
      <div className={styles.icon}>
        <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 2a8 8 0 100 16 8 8 0 000-16zm1 6.505v6H9v-6h2zM10 5c.548 0 1 .452 1 1s-.452 1-1 1-1-.452-1-1 .452-1 1-1z"
            fill="#2D2D2D"
            fillRule="evenodd"
          />
        </svg>
      </div>
      <div className={styles.text}>{children}</div>
    </div>
  );
}

InfoMessage.displayName = "InfoMessage";

InfoMessage.propTypes = {
  children: PropTypes.object.isRequired,
};
